<template>
<!--  流程记录-->
<div style="margin-top: 20px; margin-left: 10px">
  <div class="title">流程记录</div>
  <van-steps direction="vertical" :active="flowData.length" active-icon="clock" active-color="#38f" inactive-color="#38f">
    <van-step v-for="(item, index) in flowData" :key="index">
      <div v-if="index === 0">
        <div style="color: #aaaaaa; font-size: 12px;">{{flowData[0].createDate}}</div>
        <div style="display: flex; margin-top: 10px;font-size: 14px;">
          <div>
            <span>发起人: </span>
            <span  style="margin-left: 5px; font-weight: bold;">{{flowData[0].createName}}</span>
          </div>
        </div>
      </div>
      <div v-if="index !== 0">
        <div v-if="item.flowState === '审核中'" style="color: #aaaaaa; font-size: 12px;">{{item.createDate}}</div>
        <div v-else style="color: #aaaaaa; font-size: 12px;">{{item.approveTime}}</div>
        <div style="display: flex; margin-top: 10px;font-size: 14px;">
          <div>
            <span>审批人: </span>
            <span style="margin-left: 5px; font-weight: bold;">{{item.currentName}}</span>
            <span> / </span>
            <span style=" color: #53960A" :class="getClass(item.flowState)">{{item.flowState === '审核中' ? item.flowState : item.flowState === '已审核' ? '同意' : '不同意'}}</span>
          </div>
        </div>
        <div style="display: flex; margin-top: 10px; font-size: 14px;" v-if="item.flowState !== '审核中'">
          <div>审批说明: </div>
          <div style="margin-left: 5px; min-height: 30px; height: auto; overflow: hidden">{{item.message || '无'}}</div>
        </div>
      </div>
    </van-step>
  </van-steps>
</div>
</template>

<script>
import FlowSettingService from "../../api/sys/flowSettingService";
export default {
  name: "processRecord",
  props: {
    procInsId: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      flowData: [],
      flowSettingService: null
    }
  },
  created() {
    this.flowSettingService = new FlowSettingService();
    this.init(this.procInsId)
  },
  computed: {
    filterFlowData(){
      return this.flowData.slice(0, -1)
    }
  },
  methods: {
    init(id) {
      this.flowSettingService.viewFlowRecord(id).then(({data}) => {
        this.flowData = data
      })
    },
    getClass(value) {
      switch (value) {
        case '审核中':
          return 'primary';
        case '已终止':
          return 'warning';
          // 可以根据需要添加更多的状态
        default:
          return '';
      }
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 15px;
  font-weight: bold;
  padding-left: 10px;
  border-left: 5px solid #38f;
}
.primary {
  color: #5d94f8!important;
}

.warning {
  color: #BD3124!important;
}
</style>